import React, { useContext, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import {
  SearchContext,
  AutherContext,
  KBContext,
} from "../../Context";
import ArticleSearch from "../../Components/ArticleSearch/ArticleSearch";
import Layout from "../../Components/Layout";
import { CategoryLoader } from "../../Components/Loaders/CategoryLoader";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import CategoryList from "./CategoryList";
import { useSubCategoriesFeature } from "../../Context/KBContext/hooks/useFeatures";

const ArticleWrapper = styled.section`
  display: flex;
  box-sizing: border-box;
  margin: 0 180px;
  margin-top: 48px;

  align-content: center;
  justify-content: center;
  flex-direction: row;

  @media screen and (max-width: 1100px) {
    margin: 0 90px;
    margin-top: 28px;
  }

  @media screen and (max-width: 800px) {
    margin: 0 50px;
    margin-top: 18px;
  }

  @media screen and (max-width: 500px) {
    margin: 0 24px;
    margin-top: 32px;
  }

  transition: margin 1s;
`;

export default function Article() {
  const { searchList, searchInput } = useContext(SearchContext);
  const ref = useRef();
  const { data } = useContext(KBContext);
  const { isInternal } = data;
  const { redirectToken, hasPermission } = useContext(AutherContext);
  const { isSubCategoriesFeatureEnabled } = useSubCategoriesFeature();

  const showArticle = () => {
    if (isInternal !== undefined && !isInternal) {
      return true;
    } else {
      return hasPermission;
    }
  };

  const navigate = useNavigateWithSearch();

  useEffect(() => {
    if (!redirectToken && isInternal && !hasPermission) {
      localStorage.clear();
      navigate("/login");
    }
  }, [isInternal, hasPermission, redirectToken, navigate]);

  function focus() {
    ref?.current?.focus();
  }


  return showArticle() ? (
    <Layout>
      {searchInput?.length > 0 && searchList ? (
        <ArticleSearch />
      ) : (
        <ArticleWrapper ref={ref}>
          { !isSubCategoriesFeatureEnabled ? ( <CategoryList focus={focus} /> ) : null }
          <Outlet />
        </ArticleWrapper>
      )}
    </Layout>
  ) : (
    <CategoryLoader />
  );
}
